import { render, staticRenderFns } from "./apolonia.vue?vue&type=template&id=70bf5378&"
import script from "./apolonia.vue?vue&type=script&lang=js&"
export * from "./apolonia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports